import { ROLES } from '@/constants/roles';
import { planNameByRole, planInstruction } from './functions';

export const eventPlan = {
  path: '/event-plan',
  name: 'event-plan',
  component: () => import('@/modules/EventsPlan/views/events-plan.vue'),
  meta: {
    get title() {
      return planNameByRole();
    },
    icon: '$istar-outline-circle',
    new: true,
    accessList: [ROLES.operator, ROLES.department],
    get instruction() {
      return planInstruction();
    },
  },
};

export const uiEventPlan = {
  path: '/event-plan',
  name: 'event-plan',
  component: () => import('@/modules/EventsPlan/views/events-plan.vue'),
  meta: {
    layout: 'ui-design',
    buttonTitle: 'План',
    get title() {
      return planNameByRole();
    },
    new: true,
    uiDesign: true,
    wide: true,
    accessList: [ROLES.organization],
    get instruction() {
      return planInstruction();
    },
  },
};
